import { IconBase, type IconProps } from './iconBase';

import type { JSX } from 'react';

export const SoundOn = ({ type, ...rest }: IconProps): JSX.Element => (
  <IconBase viewBox='0 0 24 25' {...rest}>
    {type === 'stroke' ? (
      <path
        d='M19.071 5.68A9.88 9.88 0 0 1 22 12.708c0 2.745-1.12 5.23-2.929 7.028M15.794 8.937a5.3 5.3 0 0 1 1.572 3.771 5.3 5.3 0 0 1-1.572 3.772M2.976 8.587H5.86a1 1 0 0 0 .526-.153l5.857-3.726v16l-5.857-3.726a1 1 0 0 0-.526-.153H2.976A.973.973 0 0 1 2 15.86V9.557c0-.535.437-.97.976-.97'
        stroke='currentColor'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    ) : (
      <path
        d='M11.68 4.03a.75.75 0 0 1 1.07.678v16a.75.75 0 0 1-1.16.628L5.874 17.61a.2.2 0 0 0-.104-.031H2.952a1.71 1.71 0 0 1-1.702-1.72V9.556c0-.937.75-1.72 1.702-1.72H5.77q.054 0 .104-.03l5.718-3.726zm6.86 1.121a.75.75 0 0 1 1.06-.004 10.63 10.63 0 0 1 3.15 7.56 10.63 10.63 0 0 1-3.15 7.56.75.75 0 0 1-1.058-1.063 9.13 9.13 0 0 0 2.708-6.496 9.13 9.13 0 0 0-2.708-6.496.75.75 0 0 1-.003-1.06m-3.277 3.257a.75.75 0 0 1 1.003-.055l.057.052.202.21a6.05 6.05 0 0 1 1.591 4.093c0 1.68-.686 3.204-1.793 4.303l-.057.051a.75.75 0 0 1-1-1.115l.152-.16a4.55 4.55 0 0 0 1.198-3.08 4.55 4.55 0 0 0-1.198-3.078l-.152-.16-.052-.057a.75.75 0 0 1 .049-1.004'
        fill='currentColor'
      />
    )}
  </IconBase>
);
